import { DateTime } from "luxon";

export const getFormSubmissionPeriod = (dateRangeStartUtc: string, dateRangeEndUtc: string) => {
  const dateRangeStart = DateTime.fromISO(dateRangeStartUtc, { zone: "utc" })
    .toLocal()
    .toLocaleString(DateTime.DATE_MED);

  const dateRangeEnd = DateTime.fromISO(dateRangeEndUtc, { zone: "utc" }).toLocal().toLocaleString(DateTime.DATE_MED);

  return `${dateRangeStart} - ${dateRangeEnd}`;
};
